// extracted by mini-css-extract-plugin
module.exports = {"toggle-button-choice":"style_toggle-button-choice__jnGXg"};